import * as Sentry from "@sentry/react";
import { ConfigProvider } from "antd";
import config from "app/envConfig";
import { LoginProvider } from "providers";
import React from "react";
import { createRoot } from "react-dom/client";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import App from "./App";
import "./index.css";

Sentry.init({
  environment: config.aktosEnv,
  dsn: config.sentryDsn,
  integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV6Instrumentation(
        React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      ),
    }),
    new Sentry.Replay({
      maskAllText: false,
    }),
  ],
  tracesSampleRate: config.aktosEnv === "prod" ? 0.01 : 1.0,
  tracePropagationTargets: ["localhost", config.apiBaseUrl],

  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
});

Sentry.configureScope((scope) => {
  // Tag all events coming out of this app as 'frontend'.
  // This tag helps us differentiate frontend events from backend events.
  scope.setTag("service", "frontend");
});

const container = document.getElementById("root");
const root = createRoot(container);

const theme = {
  token: {
    colorPrimary: "#1677ff",
    colorLink: "#0098ed",
    // Sharp, modern border radius
    borderRadius: 4,
    borderRadiusSM: 3,
    borderRadiusLG: 6,
    borderRadiusXS: 2,
    // Tighter spacing — sizeXXS feeds paddingXXS which controls tag vertical padding
    sizeXXS: 2,
    paddingXS: 6,
  },
};

root.render(
  <React.StrictMode>
    <ConfigProvider theme={theme}>
      <LoginProvider>
        <App />
      </LoginProvider>
    </ConfigProvider>
  </React.StrictMode>,
);
